import type { ListOption } from '@hotjar/global-filters';

export enum HAS_EMAIL_TYPE {
  YES = 'yes',
  NO = 'no',
  ANY = 'any',
}

export const HAS_EMAIL_FILTER_OPTIONS: ListOption<HAS_EMAIL_TYPE>[] = [
  { value: HAS_EMAIL_TYPE.ANY, label: 'options.all' },
  { value: HAS_EMAIL_TYPE.YES, label: 'options.with-email' },
  { value: HAS_EMAIL_TYPE.NO, label: 'options.without-email' },
];

export type HasEmailFilterValue = HAS_EMAIL_TYPE | undefined;

export function isAllResponsesEmailFilterValue(filterValue: HasEmailFilterValue): boolean {
  return filterValue === undefined || filterValue === HAS_EMAIL_TYPE.ANY;
}
